import React, { useState, useEffect } from 'react';
import { Panel } from 'widgets/default/panel';
import { Header } from 'widgets/default/Header';
import { PanelBody } from 'widgets/default/panel/body';
import Tag from 'components/Tag'
import AsyncSelect from 'react-select/async'
import debounce from 'debounce-promise'

const Tags = ({ supplier }) => {
  const [tags, setTags] = useState([])

  useEffect(() => {
    fetch(`/rest/v2/supplier/${supplier.uid}/tags`)
      .then((response) => response.json())
      .then((tags) => setTags(tags.map(({ id, name }) => ({ value: id, label: name }))))
      .catch((error) => toastr.error(error))
  }, [supplier])

  const onChange = (tags) => {
    setTags(tags)

    fetch(`/rest/v2/supplier/${supplier.uid}/tags`, {
      method: 'POST',
      body: JSON.stringify(tags.map(({ value, label }) => ({ id: value, name: label })))
    })
      .then((response) => response.json())
      .then((tags) => {
        setTags(tags.map(({ id, name }) => ({ value: id, label: name })))
        toastr.success(`Tags updated for ${supplier.userid}`)
      })
      .catch((error) => toastr.error(error))
  }

  const loadOptions = debounce((query) => {
    return new Promise((resolve, reject) => {
      fetch(`/rest/v2/tag?search[name]=${query}`)
        .then(response => response.json())
        .then((tags) => {
          resolve(tags.map(({ uid, name }) => ({ value: uid, label: name })))
        })
        .catch(reject)
    })
  }, 250)

  return (
    <Panel>
      <Header title="Tags" />
      <PanelBody>
        <AsyncSelect
          value={tags}
          onChange={onChange}
          isMulti
          cacheOptions
          loadOptions={loadOptions}
          openMenuOnFocus
          noOptionsMessage={({ inputValue }) => `No results for '${inputValue}'`}
          loadingMessage={({ inputValue }) => `Searching for '${inputValue}'..`}
          placeholder="Tags"
        />
      </PanelBody>
    </Panel>
  );
}

export { Tags };
